import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faEnvelope,
  faPhone,
  faCalendarAlt,
  faCheckCircle,
  faTimesCircle,
  faUserCog,
} from "@fortawesome/free-solid-svg-icons";
import { formatDateOnly } from "../../utils/DateTimeUtil";

function UserCard({ user, onUserAssignmentClick, showActions = true }) {
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return formatDateOnly(dateString, "short");
  };

  return (
    <div className="info-item user-card">
      <div className="user-info">
        <div className="user-name">
          <FontAwesomeIcon icon={faUser} className="user-icon" />
          {user.firstName} {user.lastName}
          {user.isVerified ? (
            <FontAwesomeIcon
              icon={faCheckCircle}
              className="status verified"
              title="Verified"
            />
          ) : (
            <FontAwesomeIcon
              icon={faTimesCircle}
              className="status unverified"
              title="Not Verified"
            />
          )}
        </div>
        <div className="user-details">
          <div className="user-detail">
            <FontAwesomeIcon icon={faEnvelope} />
            {user.email}
          </div>
          <div className="user-detail">
            <FontAwesomeIcon icon={faPhone} />
            {user.phone}
          </div>
          <div className="user-detail">
            <FontAwesomeIcon icon={faCalendarAlt} />
            Joined: {formatDate(user.createdAt)}
          </div>
        </div>
      </div>
      {showActions && (
        <div className="user-actions">
          <button
            className="common-button secondary small"
            onClick={() => onUserAssignmentClick(user)}
            disabled={true}
            title="Assign to Group (Disabled)"
          >
            <FontAwesomeIcon icon={faUserCog} />
          </button>
        </div>
      )}
    </div>
  );
}

export default UserCard;
